var canvas, canvas2,text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 2000, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

addModify(window['canvas2']);



fabric.Text.prototype.textBaseline = 'alphabetic';




function applyEmbossShadow(textObj, mode) {
  if (!textObj) return;

  const shadowSettings = (mode === "dark")
    ? {
        color: "rgba(0,0,0,0.55)",
        blur: 14,
        offsetX: 8,
        offsetY: 8
      }
    : {
        color: "rgba(0,0,0,0.35)",
        blur: 12,
        offsetX: 6,
        offsetY: 6
      };

  textObj.set({
    shadow: new fabric.Shadow(shadowSettings)
  });

  canvas2.requestRenderAll();
}


window.currentPlateColor = 'pink'; // default

fabric.Object.prototype.setControlsVisibility({
  mtr: false
});

canvas2.selection = true;
canvas2.preserveObjectStacking = true;

canvas2.on('mouse:down', function (opt) {
  if (opt.target) {
    canvas2.setActiveObject(opt.target);
    canvas2.requestRenderAll();
  }
});



window['text1Page'] = new fabric.Text('H', {
  left: 1000,
  top: 1000,
  fontSize: 2000,
  fontFamily: 'Times New Roman',
  textAlign: 'center',
  fill: '#f3f3ee',      // default text color
  objectCaching: false,
  selectable: false,
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas2'].add(window['text1Page']);
applyEmbossShadow(window['text1Page'], 'light');

jQuery('#background_design .pinkColor').addClass('active');
setTextColor('#f4a3b5', 'dark');



function setTextColor(color, shadowMode = 'light') {
  window['text1Page'].set({
    fill: color
  });

  applyEmbossShadow(window['text1Page'], shadowMode);
  window['canvas2'].renderAll();
}


jQuery('#background_design a').on('click', function () {

  jQuery('#background_design a').removeClass('active');
  jQuery(this).addClass('active');

  // ---- PLATE COLOR STATE ----
  if (jQuery(this).hasClass('pinkColor')) {
    window.currentPlateColor = 'pink';
    setTextColor('#f4a3b5', 'dark');   // text1
  }

  if (jQuery(this).hasClass('blueColor')) {
    window.currentPlateColor = 'blue';
    setTextColor('#8ecae6', 'dark');
  }

  if (jQuery(this).hasClass('blackColor')) {
    window.currentPlateColor = 'black';
    setTextColor('#000000', 'light');
  }

  if (jQuery(this).hasClass('whiteColor')) {
    window.currentPlateColor = 'white';
    setTextColor('#eeeeee', 'dark');
  }

  // ---- TEXT2 COLOR RULE ----
  updateText2ByPlate();
});




fabric.Object.prototype.controls.deleteControl = new fabric.Control({
  visible: false
});

fabric.Object.prototype.controls.mtr.visible = false; // remove rotate icon


window['text2Page'] = new fabric.Text('check', {
  left: 960,
  top: 940,
  fontSize: 325,
  fontFamily: 'Pacifico',
  textBaseline: 'alphabetic',
  textAlign: 'center',
  fill: '#efefef',

  // 🔥 INTERACTION
  selectable: true,
  evented: true,
  hasControls: false,
  hasBorders: true,
  lockUniScaling: true,   // proportional resize
  cornerStyle: 'circle',
  cornerSize: 14,
  transparentCorners: false,

  // ✅ MOVEABLE
  lockMovementX: false,
  lockMovementY: false,

  objectCaching: false
});


function updateText2ByPlate() {
  if (!window.text2Page) return;

  if (window.currentPlateColor === 'white') {
    // white plate → black text
    setText2Color('#000000', 'dark');
  } else {
    // all other plates → white text
    setText2Color('#efefef', 'light');
  }
}


var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font1').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text2Page']);
updateText2ByPlate();
window['canvas2'].setActiveObject(window['text2Page']);
applyEmbossShadow(window['text2Page'], 'dark');

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Hadiqa') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});




function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 325; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


function setText2Color(color, shadowMode = 'dark') {
  window['text2Page'].set({ fill: color });
  applyEmbossShadow(window['text2Page'], shadowMode);
  window['canvas2'].renderAll();
}


document.getElementById('text_2').addEventListener('input', function (e) {
  const fullName = e.target.value || " ";

  // ===============================
  // Update full name text
  // ===============================
  window['text2Page'].set({ text: fullName });
  fitTextToWidth(window['text2Page'], 950);
  updateText2ByPlate();

  // ===============================
  // AUTO PICK FIRST LETTER
  // ===============================
  let firstLetter = fullName.trim().charAt(0).toUpperCase();

  window['text1Page'].set({
    text: firstLetter || ' '
  });

  applyEmbossShadow(window['text1Page'], 'light');

  // ===============================
  // Final render
  // ===============================
  window['text2Page'].bringToFront();
  window['canvas2'].renderAll();
});


document.getElementById('text_2').addEventListener('keypress', function (e) {
  if (!/^[a-zA-Z\s]$/.test(e.key)) {
    e.preventDefault();
  }
});








function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}



initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});




jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  updateFont(window['text2Page'],fontFamily);
  fitTextToWidth(window['text2Page'], 950);
});



function updateFont(activeOb,family){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontFamily',family);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}



jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});



jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text2Page'].set('text','Hadiqa');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
// var size,thumbnail;
var loadedObject,backgroundDesign,enterName,fullName,Font1,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    window['canvas2'] = canvas.toDataURL('image/png');
    backgroundDesign = jQuery('#background_design a.active').attr('value');
    enterName = jQuery('.enter_name input').val();
    fullName = jQuery('.full_name input').val();
    Font1 = jQuery('.choose_font1 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#backgroundDesign').val(backgroundDesign);
      jQuery('#enterName').val(enterName);
      jQuery('#fullName').val(fullName);
      jQuery('#Font1').val(Font1);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}